//libraries
import Vue from 'vue'
import ProviderTranslator from '../../helpers/provider-translator'
import { parsePermissions } from '@/helpers/permissions-helper'
import { setItem } from '@/helpers/storage-manager'

const state = {
  isAuth: false,
  updating_permissions: false,
  roleId: null,
  redirectUrl: null
}

//functions receive state
const getters = {
  isAuthenticated (state) {
    return Vue.prototype.$auth.isAuthenticated()
    /*return process.env.VUE_APP_ENV_MODE === 'development' ?
      Vue.prototype.$auth.isAuthenticated() : Vue.prototype.$auth0.isAuthenticated*/
  },
  async authToken (state) {
    return Vue.prototype.$auth.isAuthenticated() ? Vue.prototype.$auth.getToken() : null
    /*return process.env.VUE_APP_ENV_MODE === 'development' ?
      Vue.prototype.$auth.getToken() : await Vue.prototype.$auth0.getTokenSilently()*/
  },
  redirectTo (state) {
    return state.redirectUrl
  }
}

//functions receive context and params
const actions = {
  async login (context, params) {
    let loader = Vue.prototype.$loading.show()
    try {
      const response = await Vue.prototype.$auth.login(params.user)
      context.commit('setUser', response.data)
      context.commit('changeAuthStatus')

      if(!response.data.role_id) {
        response.data.is_new = true
      } else {
        try {
          await context.dispatch('role')
        } catch (e) {
          console.error(e.message)
        }
      }
      if (loader && loader.hide) loader.hide()
      params.callback(response.data)
    } catch (e) {
      console.error(e)
      if (loader && loader.hide) loader.hide()
      params.callback({ error: 'Usuario o contraseña no válidos.' })
    }
  },
  async sendToken (context, params) {
    try {
      let response = await Vue.request.post('send_two_factor_token', params.data)
      if(response.data.success) {
        params.callback({valid:true, enable_two_factor_auth: !!response.data.enable_two_factor_auth})
      } else {
        params.callback({ error: 'Correo o contraseña incorrectos' })
      }
    }catch (e) {
      console.log(e)
      let error = e.response && e.response.status === 401 ? 'Correo o contraseña incorrectos' : 'Ocurrió un error inesperado'
      params.callback({ error: error })
    }
  },
  async validateToken (context, params) {
    let loader = Vue.prototype.$loading.show()
    try {
      let response = await Vue.request.post('validate_two_factor_token', params)
      if(response.data.success) {
        params.callback({valid:true})
      } else {
        params.callback({ error: 'Código de acceso incorrecto o caducado' })
      }
      if (loader && loader.hide) loader.hide()
    }catch (e) {
      console.log(e)
      params.callback({ error: 'Ocurrió un error inesperado.' })
      if (loader && loader.hide) loader.hide()
    }
  },
  async autenticateAdmin (context, params) {
    let loader
    try {
      /*let user = Vue.prototype.$auth0.user;

      let admin_id = null
      let auth0_regex = user.sub.match(/auth0\|(\d*)/)
      let google_regex = user.sub.match(/^google-oauth2\|/)

      if (auth0_regex) {
        admin_id = auth0_regex[1]
      } else if (google_regex) {
        const {data} = await Vue.request.get('admin/check-by-email', {
          params: {email: user.email}
        })

        if (data.success) {
          admin_id = data.id
        } else {
          params.callback({
            error: `<p>Actualmente no tienes una cuenta con nosotros. <strong>Por favor, regístrate.</strong></p>`,
            code: 'social_login/no_account'
          })
          return
        }
      }*/

      loader = Vue.prototype.$loading.show()

      let res = await Vue.request.get('admin/me')
      console.log('res admin', res)
      if(!res.data.success) {
        if (loader && loader.hide) loader.hide()
        console.log('No admin_id found with $auth0.user.sub')
        return params.callback({ error: 'Error iniciando sesión.' })
      }

      let admin = res.data.resource

      context.commit('setUser', admin)
      context.commit('changeAuthStatus')

      if(!admin.Role && !admin.Organizations && !admin.Accounts) {
        if (loader && loader.hide) loader.hide()
        // si new admin
        res.data.is_new = true
        return params.callback(res.data)
      }

      try {
        await context.dispatch('role')
      } catch (e) {
        console.error(e.message)
      }

      if (loader && loader.hide) loader.hide()
      params.callback(res.data)
    } catch (e) {
      console.error(e)
      if (loader && loader.hide) loader.hide()
      params.callback({ error: 'Error iniciando sesión.' })
    }
  },
  async logout (context) {
    try {
      context.commit('deleteUser')
      context.commit('changeAuthStatus')
      Vue.request.post('logout')
    } catch (e) {
      console.error('Logout:', e)
    }

    context.commit('changeAuthStatus')
  },
  async authenticate (context, params) {
    try {

      // register platform in provider translator, please
      if (!params.provider || ProviderTranslator(params.provider) === undefined) {
        params.callback({ error: 'No se indicó plataforma para inicio de sesión.' })
        return
      }
      // this request is on backend
      // if (params.provider == 'shopify') {
      //   Vue.prototype.$auth.options.providers.shopify.authorizationEndpoint = `https://${params.shop}.myshopify.com/admin/oauth/authorize`
      // }

      let response = await Vue.prototype.$auth.authenticate(ProviderTranslator(params.provider), params.payload || {})
      if (response.data.success) {
        params.callback({ success: true, platform: params.provider, data: response.data.data })
      } else {
        params.callback({ error: 'Ocurrió un error iniciando sesión.' })
      }
    } catch (e) {
      console.error(e)
      params.callback({ error: 'Ocurrió un error iniciando sesión.' })
    }
  },
  async recovery ({ commit }, params) {
    try {
      let res = await Vue.request.get(`reset`, {params: params.params || {}})
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `El correo no está registrado`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error inesperado`})
      console.error(e)
    }
  },
  async recoveryToken ({ commit }, params) {
    try {
      let res = await Vue.request.post(`reset`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Por seguridad, tu link ha caducado. Por favor, solicita uno nuevo ingresando tu correo`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Por seguridad, tu link ha caducado. Por favor, solicita uno nuevo ingresando tu correo`})
      console.error(e)
    }
  },
  async reset ({ commit }, params) {
    try {
      let res = await Vue.request.patch(`reset`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Por seguridad, tu link ha caducado. Por favor, solicita uno nuevo ingresando tu correo`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error inesperado`})
      console.error(e)
    }
  },
  async register ({ commit }, params) {
    try {
      let res = await Vue.request.post(`partner/konverza/register`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Ocurrió un error inesperado con el registro`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error inesperado`})
      console.error(e)
    }
  },
  async konverza_register (context, params) {
    try {
      let res = await Vue.request.post(`konverza/signup`, params.user)
      console.log(res)
      if(res.data.success) {
        if (params.callback) params.callback(res.data)
      } else {
        let message = res.data.error && res.data.error == "user_registered" ? res.data.message : `Ocurrió un error inesperado con el registro a konverza`
        if (params.callback)
          params.callback({error: message})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error inesperado en el registro`})
      console.error(e)
    }
  },
  async konverza_registerFB (context, params) {
    try {
      let res = await Vue.request.post(`konverza/signupFB`, params.user)
      console.log(res)
      if(res.data.success) {
        if (params.callback) params.callback(res.data)
      } else {
        let message = res.data.message || `Ocurrió un error inesperado con el registro a konverza`
        if (params.callback)
          params.callback({error: message})
      }
    } catch (e) {
      console.log(e.response)
      let message = e.response.data.message || `Ocurrió un error inesperado en el registro`
      if(params.callback)
        params.callback({error: message})
    }
  },
  admin ({ commit, state }) {
    return new Promise(async (resolve, reject) => {
      let loader

      try {

        if (state.updating_permissions) return reject(new Error('Already updating permissions'))
        commit('changeUpdatingStatus', true)

        /*let user = Vue.prototype.$auth0.user;
        let admin_regex = user && user.sub ? user.sub.match(/auth0\|(\d*)/) : null
        let admin_id = admin_regex ? admin_regex[1] : null

        if (!admin_id) {
          commit('changeUpdatingStatus')
          return reject(new Error('No admin_id found with $auth0.user.sub'))
        }*/

        loader = Vue.prototype.$loading.show()

        //let res = await Vue.request.get(`admin/${admin_id}`)
        let res = await Vue.request.get('admin/me')

        if (res.data.success) {
          commit('setUser', res.data.resource)
          commit('changeAuthStatus')
        }

        commit('changeUpdatingStatus')
        if (loader && loader.hide) loader.hide()

        return resolve(true)
      } catch (e) {
        console.error(e)
        commit('changeUpdatingStatus')
        if (loader && loader.hide) loader.hide()
        return reject(new Error('Error getting user info'))
      }
    })
  },
  role ({ commit, state }) {
    return new Promise(async (resolve, reject) => {
      let loader

      try {
        if (state.updating_permissions) return reject(new Error('Already updating permissions'))
        commit('changeUpdatingStatus', true)

        let user = Vue.prototype.$getCookie('user')
        if ((!user || !user.role_id) && !state.roleId) {
          commit('changeUpdatingStatus')
          return reject(new Error('No user found with role'))
        }

        let role_id = user.role_id || state.roleId

        loader = Vue.prototype.$loading.show()
        let res = await Vue.request.get(`role/${role_id}`)
        let Role = res.data.resource;

        res = await Vue.request.get(`permission/admin?admin_id=${user.admin_id}`);
        let admin_permissions = res.data.resource;

        Role.Permissions = Role.Permissions.concat(admin_permissions.Permissions)

        if (res.data.success) {
          setItem('rules', parsePermissions(Role))
          setItem('rulesUpdatedTime', (new Date()).getTime())
          commit('updatePermissions', parsePermissions(Role))
        }
        commit('changeUpdatingStatus')
        if (loader && loader.hide) loader.hide()

        return resolve(true)
      } catch (e) {
        console.log(e)
        commit('changeUpdatingStatus')
        if (loader && loader.hide) loader.hide()
        return reject(new Error('Error getting role'))
      }
    })
  },
  async shopify ({ commit }, params) {
    try {
      let res = await Vue.request.post(`shopify/install`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Ocurrió un error conectando tu cuenta de Shopify`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error inesperado. Intenta de nuevo.`})
      console.error(e)
    }
  },
}

//functions receive state
const mutations = {
  changeAuthStatus (state) {
    state.isAuth = Vue.prototype.$auth.isAuthenticated()
  },
  setUser (state, data) {
    let {role_id, admin_id, email, partner_id, Role, first_name, refreshToken} = data
    state.roleId = role_id
    let user = {
      role_id: role_id,
      admin_id: admin_id,
      role_type: Role ? Role.type : null,
      email: email,
      first_name: first_name
    }
    if(partner_id) {
      user.partner_id = partner_id
    }
    Vue.prototype.$setCookie('user', user)
    Vue.prototype.$setCookie('refreshToken', refreshToken)
  },
  deleteUser (state) {
    Vue.prototype.$cookies.remove('user')
  },
  updatePermissions () {
    // this is for the plugin to update the permissions object
  },
  destroySession () {
    // this is for the plugin to update the permissions object
  },
  changeUpdatingStatus (state, value) {
    state.updating_permissions = value || false
  },
  setRedirectUrl (state, value) {
    state.redirectUrl = value
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
